"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAdvancedReport = createAdvancedReport;
exports.getAdvancedReportById = getAdvancedReportById;
exports.getAdvancedReportHikeParticipants = getAdvancedReportHikeParticipants;
exports.getAdvancedReports = getAdvancedReports;
exports.updateAdvancedReport = updateAdvancedReport;
var _request = _interopRequireDefault(require("@/utils/request"));
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
// import { fileURLToPath } from 'url'

function getAdvancedReports(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };

  // LHVO-5400 Pass source=adminPortal when calling Get Hike Advanced Reports API, so that it filters records by tenant
  query.source = Constants.SOURCE_ADMIN_PORTAL;
  return (0, _request.default)({
    url: `/hike-advanced-reports`,
    method: 'get',
    headers,
    params: query
  });
}
function getAdvancedReportById(token, reportId) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/hike-advanced-reports/${reportId}`,
    method: 'get',
    headers
  });
}
function getAdvancedReportHikeParticipants(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: `/hike-advanced-reports/hike-participants`,
    method: 'post',
    headers,
    data
  });
}
function createAdvancedReport(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: `/hike-advanced-reports`,
    method: 'post',
    headers,
    data
  });
}
function updateAdvancedReport(token, reportId, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: `/hike-advanced-reports/${reportId}`,
    method: 'post',
    headers,
    data
  });
}